import api from '@pray/shared/utils/api';

import type { RecurringPushCampaignDetail } from './types';

// GET …/campaigns/recurring-push/:id — `sendObjectResponse(res, { object: dto })`.
// The api wrapper adds one `data` layer, the server envelope adds another.
export async function getRecurringPushCampaign({
  artistId,
  recurringCampaignId,
}: {
  artistId: string;
  recurringCampaignId: string;
}): Promise<{ object: RecurringPushCampaignDetail }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring-push/${recurringCampaignId}`;
  const response = await api.executeGetRequest<{ data: { object: RecurringPushCampaignDetail } }>(url);
  return response.data.data;
}
